import React from "react";
import "./styles.scss";
import Radial from "../Radial";
import { formatNumberForOdds } from "../../../../utils/utils";

export default function Wining(props: any) {
  const { isWinning, value, endWin, lang } = props;
  return (
    <div
      className={`wrap-result-content animate__animated animate-delay-0
  ${isWinning && "animate__bounceIn animate-delay-09"}
  ${endWin && "animate__fadeOut"}
`}
    >
      <div
        className={`wrap-content-winning ${
          isWinning && "wrap-content-winning-show"
        }`}
      >
        <Radial lang={lang} />
        <div
          className={`value-winning 
          ${value >= 1000 && "value-winning-value-max"}
          `}
        >
          <span className="syb">$</span>
          <span className="value">{formatNumberForOdds(value)}</span>
        </div>
      </div>
    </div>
  );
}
